import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserPropertyShortlist_CheckShortlist, UserPropertyShortlist_Create, UserPropertyShortlist_Delete, UserPropertyShortlist_GetUserShortlistProject, UserPropertyShortlist_GetUserShortlistProperties, UserPropertyShortlist_ReadAll, UserPropertyShortlist_ReadById, UserPropertyShortlist_ReadByMasterId, UserPropertyShortlist_ReadByUserId, UserPropertyShortlist_Update } from "src/app/GlobalVariable";
import { UserPropertyShortlistCheckShortlistRequestDTO, UserPropertyShortlistCreateRequestDTO, UserPropertyShortlistDeleteRequestDTO, UserPropertyShortlistDTO, UserPropertyShortlistGetUserShortlistProjectRequestDTO, UserPropertyShortlistGetUserShortlistProjectResponseList, UserPropertyShortlistGetUserShortlistPropertiesRequestDTO, UserPropertyShortlistGetUserShortlistPropertiesResponseList, UserPropertyShortlistList, UserPropertyShortlistReadByIdRequestDTO, UserPropertyShortlistReadByMasterIdRequestDTO, UserPropertyShortlistReadByUserIdRequestDTO, UserPropertyShortlistUpdateRequestDTO } from "./userpropertyshortlist.interface";

@Injectable({
    providedIn: 'root'
})

export class UserPropertyShortlistService {
    private http = inject(HttpClient);

    UserPropertyShortlist_Create(data: UserPropertyShortlistCreateRequestDTO): Observable<UserPropertyShortlistDTO> {
        return this.http.post<UserPropertyShortlistDTO>(UserPropertyShortlist_Create, data);
    }

    UserPropertyShortlist_Update(data: UserPropertyShortlistUpdateRequestDTO): Observable<UserPropertyShortlistDTO> {
        return this.http.post<UserPropertyShortlistDTO>(UserPropertyShortlist_Update, data);
    }

    UserPropertyShortlist_ReadAll(): Observable<UserPropertyShortlistList> {
        return this.http.get<UserPropertyShortlistList>(UserPropertyShortlist_ReadAll);
    }

    UserPropertyShortlist_Delete(data: UserPropertyShortlistDeleteRequestDTO): Observable<UserPropertyShortlistDTO> {
        return this.http.post<UserPropertyShortlistDTO>(UserPropertyShortlist_Delete, data);
    }

    UserPropertyShortlist_ReadById(data: UserPropertyShortlistReadByIdRequestDTO): Observable<UserPropertyShortlistDTO> {
        return this.http.post<UserPropertyShortlistDTO>(UserPropertyShortlist_ReadById, data);
    }

    UserPropertyShortlist_ReadByUserId(data: UserPropertyShortlistReadByUserIdRequestDTO): Observable<UserPropertyShortlistList> {
        return this.http.post<UserPropertyShortlistList>(UserPropertyShortlist_ReadByUserId, data);
    }

    UserPropertyShortlist_ReadByMasterId(data: UserPropertyShortlistReadByMasterIdRequestDTO): Observable<UserPropertyShortlistList> {
        return this.http.post<UserPropertyShortlistList>(UserPropertyShortlist_ReadByMasterId, data);
    }

    UserPropertyShortlist_CheckShortlist(data: UserPropertyShortlistCheckShortlistRequestDTO): Observable<UserPropertyShortlistDTO> {
        return this.http.post<UserPropertyShortlistDTO>(UserPropertyShortlist_CheckShortlist, data);
    }

    UserPropertyShortlist_GetUserShortlistProperties(data: UserPropertyShortlistGetUserShortlistPropertiesRequestDTO): Observable<UserPropertyShortlistGetUserShortlistPropertiesResponseList> {
        return this.http.post<UserPropertyShortlistGetUserShortlistPropertiesResponseList>(UserPropertyShortlist_GetUserShortlistProperties, data);
    }

    UserPropertyShortlist_GetUserShortlistProject(data: UserPropertyShortlistGetUserShortlistProjectRequestDTO): Observable<UserPropertyShortlistGetUserShortlistProjectResponseList> {
        return this.http.post<UserPropertyShortlistGetUserShortlistProjectResponseList>(UserPropertyShortlist_GetUserShortlistProject, data)
    }
}